import { render, staticRenderFns } from "./POTax.vue?vue&type=template&id=4c54cfcf&scoped=true"
import script from "./POTax.vue?vue&type=script&lang=js"
export * from "./POTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54cfcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c54cfcf')) {
      api.createRecord('4c54cfcf', component.options)
    } else {
      api.reload('4c54cfcf', component.options)
    }
    module.hot.accept("./POTax.vue?vue&type=template&id=4c54cfcf&scoped=true", function () {
      api.rerender('4c54cfcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/POTax.vue"
export default component.exports